import React, { useState } from 'react'
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import KysTwoForm from './KysTwoTabs/KysTwoForm/KysTwoForm';
import TrackExceptionApproval from './KysTwoTabs/TrackExceptionApproval/TrackExceptionApproval';
import LevelFiveKys from './KysTwoTabs/LevelFiveKys/LevelFiveKys';

const KysTwo = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    const { viewDataFromSupplier } = props;
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const hlverticaltabs = "hl-vertical-tabs";
    return (
        <div className='hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3'>
            <div className={hlverticaltabs}>
                <Row className='hl-tab'>
                    {/* <Col lg="2">
                        <div className='h-100'>
                            <Nav vertical tabs>
                                <NavItem className={activeTab === '1' ? 'active' : ''}>
                                    <NavLink onClick={() => toggleTab('1')}>
                                        KYS 2 Form
                                    </NavLink>
                                </NavItem>
                                <NavItem className={activeTab === '2' ? 'active' : ''}>
                                    <NavLink onClick={() => toggleTab('2')}>
                                        Track Exception Approval
                                    </NavLink>
                                </NavItem>
                                <NavItem className={activeTab === '3' ? 'active' : ''}>
                                    <NavLink onClick={() => toggleTab('3')}>
                                        Level 5 Approval
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Col> */}
                    <Col lg="12">
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <KysTwoForm viewDataFromSupplier={viewDataFromSupplier} />
                            </TabPane>
                            <TabPane tabId="2">
                                <TrackExceptionApproval />
                            </TabPane>
                            <TabPane tabId="3">
                                <LevelFiveKys />
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default KysTwo;
